import { render, staticRenderFns } from "./Sidemenu.vue?vue&type=template&id=5afe18c4&"
import script from "./Sidemenu.vue?vue&type=script&lang=ts&"
export * from "./Sidemenu.vue?vue&type=script&lang=ts&"
import style0 from "./Sidemenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports